export default "images/guy.png";